import alertTone from '@app/assets/alert-tone.mp3'

export const defaultAlertTone = alertTone
